import Reveal from '@/components/feature/Reveal';
import { SectionWrapper, SectionHeading } from '@/components/feature/SectionHeading';

const companyData = [
  { label: '社名', value: '株式会社ルヴィラ' },
  { label: '英字表記', value: 'Luvira Inc.' },
  { label: '代表者', value: '成相 政和' },
  { label: '所在地', value: '兵庫県神戸市中央区磯辺通1丁目1番18号　カサベラ国際プラザビル707号室' },
  { label: '設立', value: '2025年' },
  {
    label: '事業内容',
    value: 'AI業務改善・AIシステム開発・AI運用・改善支援・AI集客支援・Luvira ASA',
  },
  { label: 'メール', value: 'contact@luvira.co.jp' },
  { label: '電話', value: '050-5367-5817' },
  { label: 'Web', value: 'www.luvira.co.jp' },
];

export default function Company() {
  return (
    <SectionWrapper className="bg-[#12121f]">
      <SectionHeading
        eyebrow="Company"
        title="会社概要"
        description="AIを活用して会社の成長を妨げる業務・情報・判断の滞りを見つけ、改善につなげるパートナーです。"
      />

      <Reveal className="mt-12 md:mt-16 max-w-4xl mx-auto">
        <div className="bg-[#1a1a2e] border border-[#2a2a3e] rounded-2xl overflow-hidden">
          <table className="w-full text-left">
            <tbody>
              {companyData.map((row, i) => (
                <tr key={row.label} className={i !== 0 ? 'border-t border-[#2a2a3e]' : ''}>
                  <th className="px-6 md:px-8 py-5 text-sm font-semibold text-white w-24 sm:w-32 md:w-44 align-top whitespace-nowrap">
                    {row.label}
                  </th>
                  <td className="px-6 md:px-8 py-5 text-sm text-[#a0a0b0] leading-relaxed break-words align-top">{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Reveal>
    </SectionWrapper>
  );
}